import React, { useEffect, useMemo, useState, useCallback } from 'react';
import { Field } from 'formik';
import NoCptWidget from './widgets/NoCptWidget';
import { GET_CPTS_COLUMNS, sortOptions } from './constants';
import QhsTable from '../../../../../../../Shared/Table/Table';
import CptEndCheckbox from './widgets/CptEndCheckbox';
import { useGenerateColumns, getSortedData } from '../../../../../../../Shared/Table/helpers';
import {
  TABLE_KEYS
} from '../../../../../../../../redux_store/reducer/reducers/tableReducer/tableReducer';

const Cpts = ({
                validateField,
                setErrors,
                backendErrors,
                cpts,
                setCpts,
                loadingCptCodes,
                cptCodes,
                resetFiltersTrigger,
                setResetFiltersTrigger,
                updateFieldValue,
                values,
              }) => {
  const [filter, setFilter] = useState([]);
  const [sort, setSort] = useState([]);
  // const [tableKey, settableKey] = useState(0);
  const [filteredData, setFilteredData] = useState([]);
  const getSortedAndFilteredData = (newFilters, newSort) =>
    getSortedData(
      cpts, //getFilteredData(cpts, newFilters, filterOptions),
      newSort,
      sortOptions,
    );
  //
  // const onSort = useCallback((sortObj) => {
  //   setSort(sortObj);
  //   setFilteredData(getSortedAndFilteredData(filter, sortObj()[0]));
  //   settableKey(tableKey + 1);
  // }, [filter]);
  //
  // const onFilter = useCallback((newFilters) => {
  //   setFilter(newFilters);
  //   setFilteredData(getSortedAndFilteredData(newFilters(), sort));
  //   settableKey(tableKey + 1);
  // }, [sort]);

  useEffect(() => {
    setFilteredData(getSortedAndFilteredData(filter, sort));
  }, [cpts]);

  useEffect(() => {
    if (resetFiltersTrigger) {
      const timeoutId = setTimeout(() => {
        setFilteredData(cpts);
        setFilter({});
        setResetFiltersTrigger(false);
      }, 300);
      return () => clearTimeout(timeoutId);
    }
  }, [resetFiltersTrigger, cpts, setResetFiltersTrigger]);
  const tableKey = TABLE_KEYS.cptsTable;

  const args = useMemo(
    () => {
      return {
        cptCodes: cptCodes,
        values: values,
        updateFieldValue: updateFieldValue,
        validateField: validateField,
        backendErrors: backendErrors?.ispConfiguration?.services || {},
      };
    },
    [cptCodes, updateFieldValue, validateField, backendErrors?.ispConfiguration?.services, values],
  );

  const columns = useGenerateColumns(GET_CPTS_COLUMNS, tableKey, { args }, {}).columns;

  const renderRowActions = useCallback(({ row: { index: index } }) => {
    return <Field type='text' name='ispConfiguration.services'>
      {({ form }) => (<CptEndCheckbox
          form={form}
          backendErrors={backendErrors}
          cpts={cpts}
          setCpts={setCpts}
          setErrors={setErrors}
          validateField={validateField}
          index={parseInt(index)}
        />
      )}
    </Field>;
  }, [backendErrors, cpts, setCpts, setErrors, validateField]);

  if (!cpts?.length) {
    return <NoCptWidget />;
  }

  return <QhsTable
    columns={columns}
    data={filteredData || []}
    fetchNextPage={() => {
    }}
    isFetching={false}
    isLoading={loadingCptCodes}
    totalRowCount={filteredData.length}
    setData={setFilteredData}
    enableEditing={true}
    rowActionsTitleSize={40}
    renderRowActions={renderRowActions}
    tableKey={tableKey}
  />;
};

export default Cpts;
